import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, Col, Label, Input, Button } from "reactstrap"
import Select from "react-select"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { fetchPvsCategory } from "../../../redux/actions/pvs"
import { getProductList } from "../../../redux/actions/user"
import TagInput from "components/TagInput"

const stateOptions = [
  {
    options: [
      {
        label: "Andaman and Nicobar Islands",
        value: 4023,
      },
      {
        label: "Andhra Pradesh",
        value: 4017,
      },
      {
        label: "Arunachal Pradesh",
        value: 4024,
      },
      {
        label: "Assam",
        value: 4027,
      },
      {
        label: "Bihar",
        value: 4037,
      },
      {
        label: "Chandigarh",
        value: 4031,
      },
      {
        label: "Chhattisgarh",
        value: 4040,
      },
      {
        label: "Dadra and Nagar Haveli and Daman and Diu",
        value: 4033,
      },
      {
        label: "Delhi",
        value: 4021,
      },
      {
        label: "Goa",
        value: 4009,
      },
      {
        label: "Gujarat",
        value: 4030,
      },
      {
        label: "Haryana",
        value: 4007,
      },
      {
        label: "Himachal Pradesh",
        value: 4020,
      },
      {
        label: "Jammu and Kashmir",
        value: 4029,
      },
      {
        label: "Jharkhand",
        value: 4025,
      },
      {
        label: "Karnataka",
        value: 4026,
      },
      {
        label: "Kerala",
        value: 4028,
      },
      {
        label: "Ladakh",
        value: 4852,
      },
      {
        label: "Lakshadweep",
        value: 4019,
      },
      {
        label: "Madhya Pradesh",
        value: 4039,
      },
      {
        label: "Maharashtra",
        value: 4008,
      },
      {
        label: "Manipur",
        value: 4010,
      },
      {
        label: "Meghalaya",
        value: 4006,
      },
      {
        label: "Mizoram",
        value: 4036,
      },
      {
        label: "Nagaland",
        value: 4018,
      },
      {
        label: "Odisha",
        value: 4013,
      },
      {
        label: "Puducherry",
        value: 4011,
      },
      {
        label: "Punjab",
        value: 4015,
      },
      {
        label: "Rajasthan",
        value: 4014,
      },
      {
        label: "Sikkim",
        value: 4034,
      },
      {
        label: "Tamil Nadu",
        value: 4035,
      },
      {
        label: "Telangana",
        value: 4012,
      },
      {
        label: "Tripura",
        value: 4038,
      },
      {
        label: "Uttar Pradesh",
        value: 4022,
      },
      {
        label: "Uttarakhand",
        value: 4016,
      },
      {
        label: "West Bengal",
        value: 4853,
      },
    ],
  },
]

const About = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [selectedPvsCard, setSelectedPvsCard] = useState(null)
  const [pvsOptions, setPvsOptions] = useState([])
  const [productOptions, setProductOptions] = useState([])

  const products = useSelector(state => state.user.products)
  const pvs_cards = useSelector(state => state.auth.pvs_cards)
  const categoryList = useSelector(state => state.pvs.categoryList)

  useEffect(() => {
    dispatch(fetchPvsCategory({ offset: 1 }))
  }, [])

  useEffect(() => {
    if (pvs_cards && pvs_cards.length > 0) {
      let tempOptions = []
      tempOptions = pvs_cards.map(card => ({
        ...card,
        label: card.token_code,
        value: card.token_code,
      }))
      setPvsOptions(tempOptions)

      let category = categoryList.find(
        value => value.pvs_cat_id === Number(tempOptions[0].categories)
      )
      dispatch(
        getProductList({offset: 1})
      )
      setSelectedPvsCard(tempOptions[0])
    }
  }, [pvs_cards])

  useEffect(() => {
    if (products) {

      let tempProductOption = []
      products.map(option => {
        tempProductOption.push({
          label: option.product_label,
          value: option.product_id,
          encId: option.enc_product_id,
        })
      })
      setProductOptions(tempProductOption)
    }
  }, [products])

  useEffect(() => {
    if (selectedPvsCard) {
      const billing = selectedPvsCard.billing || {}
      formik.setValues({
        firstName: billing.first_name || "",
        lastName: billing.last_name || "",
        companyName: billing.company_name || "",
        address: billing.address || "",
        city: billing.city || "Pune",
        state: billing.state
          ? stateOptions[0].options.find(val => val.label === billing.state)
          : stateOptions[0].options[20],
        pincode: billing.pincode || "",
        gstNumber: billing.gst_number || "",
        email: billing.email_id || "",
        mobileNo: billing.mobile_no || "",
        products: [],
        otherProducts: [],
        showDirectory: !!selectedPvsCard.show_my_directory,
        showContactNumber: !!selectedPvsCard.show_contact_number,
        showEmail: !!selectedPvsCard.show_email,
        showWhatsapp: !!selectedPvsCard.show_whatsapp_number,
        directoryDescription: selectedPvsCard.description || "",
      })
    }
    if (selectedPvsCard && selectedPvsCard.products && productOptions) {
      let productArr = selectedPvsCard.products.split(",")

      let selectedProducts = []

      productArr.map(product => {

        const foundProduct = productOptions.find(
          val => val.value === Number(product)
        )
        if (foundProduct) {
          selectedProducts.push(foundProduct)
        }
      })
      formik.setFieldValue("products", selectedProducts)
    }
  }, [selectedPvsCard, productOptions])

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      companyName: "",
      region: null,
      address: "",
      city: "Pune",
      state: stateOptions[0].options[20],
      pincode: "",
      gstNumber: "",
      email: "",
      mobileNo: "",
      products: [], //selected products
      otherProducts: [], //other products
      showDirectory: false,
      showContactNumber: false,
      showEmail: false,
      showWhatsapp: false,
      directoryDescription: "",
    },
    validationSchema: Yup.object({
      products: Yup.array().min(1, "At least one product must be selected"),
    }),
    onSubmit: values => {
      let requestBody = {
        section: "bussiness",
        data: [
          {
            pvs_entry_id: selectedPvsCard.pvs_entry_id,
            products: values.products.map(product => product.value).join(","),
            other_products: values.otherProducts.join(", "),
            description: values.directoryDescription,
            show_my_directory: values.showDirectory ? 1 : 0,
            show_contact_number: values.showContactNumber ? 1 : 0,
            show_whatsapp_number: values.showWhatsapp ? 1 : 0,
            show_email: values.showEmail ? 1 : 0,
            billing: {
              customer_type: "business", //business, individual
              first_name: values.firstName,
              last_name: values.lastName,
              email_id: values.email,
              mobile_no: values.mobileNo,
              gst_number: values.gstNumber,
              company_name: values.companyName,
              region: values.region,
              address: values.address,
              city: values.city,
              state: values.state.label,
              pincode: values.pincode,
            },
          },
        ],
      }
      props.submitProfileChanges(requestBody)
    },
  })

  const handlePvsCardChange = selectedOption => {
    let category = categoryList.find(
      value => value.pvs_cat_id === Number(selectedOption.categories)
    )
    dispatch(
      getProductList({
        enc_pvs_cat_id: category.enc_pvs_cat_id,
      })
    )
    setSelectedPvsCard(selectedOption)
  }
  return pvsOptions.length > 0 ? (
    <form onSubmit={formik.handleSubmit}>
      <div>
        {/* PVS Cards Selection */}
        <Card className="mb-4">
          <CardBody>
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <Label htmlFor="pvsCards" className="form-label">
                    Select PVS Card <span className="text-danger">*</span>
                  </Label>
                  <Select
                    id="pvsCards"
                    name="pvsCards"
                    options={pvsOptions}
                    classNamePrefix="select"
                    placeholder="Select your PVS Card..."
                    value={selectedPvsCard}
                    onChange={handlePvsCardChange}
                  />
                  {formik.touched.selectedPvsCard &&
                    formik.errors.selectedPvsCard && (
                      <div className="text-danger small mt-1">
                        {formik.errors.selectedPvsCard}
                      </div>
                    )}
                </div>
              </Col>
            </Row>

            {/* Category and Subcategory - View Only */}
            {/* {selectedPvsCard && ( */}
            <>
              <h5 className="nom-title mt-4">Product Details</h5>
              <Row>
                <Col md="6">
                  <div className="mb-3">
                    <Label htmlFor="category" className="form-label">
                      Category
                    </Label>
                    <Input
                      id="category"
                      name="category"
                      type="text"
                      className="form-control"
                      value={selectedPvsCard?.categories_label}
                      readOnly
                      style={{ backgroundColor: "#f8f9fa" }}
                    />
                  </div>
                </Col>
                <Col md="6">
                  <div className="mb-3">
                    <Label htmlFor="subcategory" className="form-label">
                      Subcategory
                    </Label>
                    <Input
                      id="subcategory"
                      name="subcategory"
                      type="text"
                      className="form-control"
                      value={selectedPvsCard?.subcategories_label}
                      readOnly
                      style={{ backgroundColor: "#f8f9fa" }}
                    />
                  </div>
                </Col>
              </Row>

              {/* Products Multi-Select */}
              <Row>
                <Col md="12">
                  <div className="mb-3">
                    <Label htmlFor="products" className="form-label">
                      Products <span className="text-danger">*</span>
                    </Label>
                    <Select
                      id="products"
                      name="products"
                      isMulti
                      options={productOptions}
                      classNamePrefix="select"
                      placeholder="Select products..."
                      value={formik.values.products}
                      onChange={val => formik.setFieldValue("products", val)}
                      onBlur={() => formik.setFieldTouched("products", true)}
                    />
                    {formik.touched.products && formik.errors.products && (
                      <div className="text-danger small mt-1">
                        {formik.errors.products}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="">
                  <Label htmlFor="txtOtherProducts" className="form-label">
                    Other Products
                  </Label>
                  <TagInput
                    tags={formik.values.otherProducts}
                    title="If you don’t find your product in the list above, please type it here to add it."
                    onChange={val => formik.setFieldValue("otherProducts", val)}
                    buttonTitle="Add"
                    onAddClick={(value, allTags) => {
                      formik.setFieldValue("otherProducts", allTags)
                    }}
                  />
                  {formik.touched.otherProducts &&
                    formik.errors.otherProducts && (
                      <div className="text-danger small mt-1">
                        {formik.errors.otherProducts}
                      </div>
                    )}
                </Col>
              </Row>
            </>
            {/* )} */}

            <h5 className="nom-title mt-4">Billing Details</h5>
            <div className="row mb-3 pb-3" hidden>
              <div className="col-12 col-sm-3">
                <Label className="form-label gap-3 d-flex align-items-center">
                  Customer Type:&nbsp;
                  <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-9">
                <div className="form-check form-check-inline pl-4">
                  <Input
                    type="radio"
                    id="customRadioInline1"
                    name="customerType"
                    value="business"
                    className="form-check-input"
                    onChange={formik.handleChange}
                    checked={formik.values.customerType === "business"}
                  />
                  <Label
                    className="form-check-label"
                    htmlFor="customRadioInline1"
                  >
                    Business
                  </Label>
                </div>
                <div className="form-check form-check-inline">
                  <Input
                    type="radio"
                    id="customRadioInline2"
                    name="customerType"
                    value="individual"
                    className="form-check-input"
                    onChange={formik.handleChange}
                    checked={formik.values.customerType === "individual"}
                  />
                  <Label
                    className="form-check-label"
                    htmlFor="customRadioInline2"
                  >
                    Individual
                  </Label>
                </div>
              </div>
            </div>

            {/* Primary Contact */}
            <div className="mb-3 row mt-3">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="primary_contact">
                  Primary Contact &nbsp;
                  <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm">
                <div className="row">
                  <div className="col-12 col-sm-6 mb-3">
                    <Input
                      name="firstName"
                      className="form-control"
                      placeholder="First Name"
                      type="text"
                      id="first_name"
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                      // onBlur={formik.handleBlur}
                    />
                    {formik.errors.firstName && (
                      <div className="text-danger small mt-1">
                        {formik.errors.firstName}
                      </div>
                    )}
                  </div>
                  <div className="col-12 col-sm-6">
                    <Input
                      name="lastName"
                      className="form-control"
                      placeholder="Last Name"
                      id="last_name"
                      type="text"
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                      // onBlur={formik.handleBlur}
                    />
                    {formik.errors.lastName && (
                      <div className="text-danger small mt-1">
                        {formik.errors.lastName}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Company Name */}
            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="company_name">
                  Company Name &nbsp;
                </Label>
              </div>
              <div className="col-12 col-sm-9">
                <Input
                  name="companyName"
                  className="form-control"
                  type="text"
                  id="company_name"
                  value={formik.values.companyName}
                  onChange={formik.handleChange}
                  // onBlur={formik.handleBlur}
                />
                {formik.errors.companyName && (
                  <div className="text-danger small mt-1">
                    {formik.errors.companyName}
                  </div>
                )}
              </div>
            </div>

            {/* <div className="border-top my-4"></div> */}

            <h5 className="nom-title mt-4">Billing Address</h5>

            {/* Address textarea */}
            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="address">
                  Address &nbsp;
                  <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-9">
                <textarea
                  name="address"
                  className="form-control"
                  id="address"
                  rows="3"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  // onBlur={formik.handleBlur}
                ></textarea>
                {formik.errors.address && (
                  <div className="text-danger small mt-1">
                    {formik.errors.address}
                  </div>
                )}
              </div>
            </div>

            {/* State */}
            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="company_name">
                  State &nbsp;
                  <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Select
                  name="state"
                  value={formik.values.state}
                  onChange={val => {
                    formik.setFieldValue("state", val)
                  }}
                  options={stateOptions}
                  classNamePrefix="select2-selection"
                />
                {formik.errors.state && (
                  <div className="text-danger small mt-1">
                    {formik.errors.state}
                  </div>
                )}
              </div>
            </div>

            {/* City */}
            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="city">
                  City &nbsp;
                  <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                {/* <Select
                              name="city"
                              value={formik.values.city}
                              onChange={val =>
                                formik.setFieldValue("city", val)
                              }
                              options={cityOptions}
                              classNamePrefix="select2-selection"
                            /> */}

                <Input
                  name="city"
                  className="form-control"
                  type="text"
                  id="city"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  // onBlur={formik.handleBlur}
                />
                {formik.errors.city && (
                  <div className="text-danger small mt-1">
                    {formik.errors.city}
                  </div>
                )}
              </div>
            </div>

            {/* Pincode */}
            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="company_name">
                  Pin Code &nbsp;
                  <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Input
                  name="pincode"
                  className="form-control"
                  type="number"
                  id="pincode"
                  value={formik.values.pincode}
                  onChange={formik.handleChange}
                  // onBlur={formik.handleBlur}
                />
                {formik.errors.pincode && (
                  <div className="text-danger small mt-1">
                    {formik.errors.pincode}
                  </div>
                )}
              </div>
            </div>

            {/* GST Number */}
            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="company_name">
                  GST Number
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Input
                  name="gstNumber"
                  className="form-control"
                  type="text"
                  id="gst_number"
                  value={formik.values.gstNumber}
                  onChange={formik.handleChange}
                  // onBlur={formik.handleBlur}
                />
                {/* {formik.errors.gstNumber && (
                              <div className="text-danger small mt-1">
                                {formik.errors.gstNumber}
                              </div>
                            )} */}
              </div>
            </div>
            {/* Email ID */}
            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="company_name">
                  Email ID &nbsp;
                  <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Input
                  name="email"
                  className="form-control"
                  type="email"
                  id="emailr"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                {formik.errors.email && (
                  <div className="text-danger small mt-1">
                    {formik.errors.email}
                  </div>
                )}
              </div>
            </div>
            {/* Phone Number */}
            <div className="mb-3 row">
              <div className="col-12 col-sm-3">
                <Label className="form-label" htmlFor="company_name">
                  Mobile Number &nbsp;
                  <span className="text-danger">*</span>
                </Label>
              </div>
              <div className="col-12 col-sm-5">
                <Input
                  name="mobileNo"
                  className="form-control"
                  type="number"
                  id="Mob_number"
                  value={formik.values.mobileNo}
                  onChange={formik.handleChange}
                />
                {formik.errors.mobileNo && (
                  <div className="text-danger small mt-1">
                    {formik.errors.mobileNo}
                  </div>
                )}
              </div>
            </div>
          </CardBody>
        </Card>

        {/* Directory Settings */}
        <Card className="mb-4">
          <CardBody className="p-0">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h5 className="nom-title mt-4 mb-0">Directory Settings</h5>
              {selectedPvsCard && selectedPvsCard.brand_slug && (
                <a
                  href={"https://pulapuneladies.com/directory/" + selectedPvsCard.brand_slug}
                  target="_blank"
                  rel="noreferrer"
                  className="d-flex align-items-center gap-1"
                  style={{ fontSize: "0.875rem", color: "#880356" }}
                >
                  <i className="bx bx-link-external"></i>
                  Preview Directory Page
                </a>
              )}
            </div>

            <p className="mb-4 text-muted" style={{ fontSize: "0.875rem" }}>
              <i className="bx bx-info-circle me-1" style={{ color: "#880356" }}></i>
              This is the info that will be shown on your directory page. To
              make changes,{" "}
              <a
                href="https://wa.me/918308011762"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#880356", fontWeight: 600 }}
              >
                <i className="bx bxl-whatsapp me-1"></i>
                Contact Admin
              </a>
              .
            </p>

            <Row className="mb-1">
              {[
                { id: "showDirectory", label: "Show my directory", icon: "bx bx-user-circle" },
                { id: "showContactNumber", label: "Show Contact Number", icon: "bx bx-phone" },
                { id: "showEmail", label: "Show Email", icon: "bx bx-envelope" },
                { id: "showWhatsapp", label: "Show Whatsapp Number", icon: "bx bxl-whatsapp" },
              ].map(({ id, label, icon }) => {
                const isSubToggle = id !== "showDirectory"
                const disabled = isSubToggle && !formik.values.showDirectory
                const active = formik.values[id] && !disabled
                return (
                  <Col md="6" key={id}>
                    <Label
                      className="mb-3 d-flex align-items-center justify-content-between p-3 rounded"
                      style={{
                        border: `2px solid ${active ? "#880356" : "#dee2e6"}`,
                        backgroundColor: disabled ? "#f0f0f0" : active ? "#fff0fa" : "#f8f9fa",
                        cursor: disabled ? "not-allowed" : "pointer",
                        opacity: disabled ? 0.5 : 1,
                        transition: "all 0.2s ease",
                      }}
                    >
                      <span className="d-flex align-items-center gap-2 fw-medium">
                        <i
                          className={`${icon} fs-5`}
                          style={{ color: disabled ? "#aaa" : "#880356" }}
                        ></i>
                        {label}
                      </span>
                      <div
                        style={{
                          width: "46px",
                          height: "24px",
                          borderRadius: "12px",
                          backgroundColor: active ? "#880356" : "#ced4da",
                          position: "relative",
                          transition: "background-color 0.2s ease",
                          flexShrink: 0,
                        }}
                      >
                        <div
                          style={{
                            width: "18px",
                            height: "18px",
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                            position: "absolute",
                            top: "3px",
                            left: active ? "25px" : "3px",
                            transition: "left 0.2s ease",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                          }}
                        />
                      </div>
                      <Input
                        id={id}
                        name={id}
                        type="checkbox"
                        className="d-none"
                        checked={formik.values[id]}
                        onChange={formik.handleChange}
                        disabled={disabled}
                      />
                    </Label>
                  </Col>
                )
              })}
            </Row>

            {!formik.values.showDirectory && (
              <p className="mb-4 text-muted" style={{ fontSize: "0.85rem" }}>
                <i className="bx bx-hide me-1 text-danger"></i>
                Your directory is not visible to others. Enable{" "}
                <strong>Show my directory</strong> to make it public.
              </p>
            )}

            <Row>
              <Col md="12">
                <div className="mb-3">
                  <Label htmlFor="directoryDescription" className="form-label">
                    Description
                  </Label>
                  <Input
                    id="directoryDescription"
                    name="directoryDescription"
                    type="textarea"
                    className="form-control"
                    placeholder="Enter a description for your directory listing"
                    rows="4"
                    value={formik.values.directoryDescription}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <div className="d-flex justify-content-end">
          <Button color="primary" type="submit">
            Save Changes
          </Button>
        </div>
      </div>
    </form>
  ) : (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "250px" }}
    >
      <p>Register as a PVS Member to get started</p>
      <Button
        color="primary"
        className="mt-2"
        onClick={() => navigate("/pvs-info")}
      >
        Become a PVS Member
      </Button>
    </div>
  )
}

export default About
